"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _wrappedComponent = _interopRequireDefault(require("./wrapped-component"));

var _registrar = _interopRequireDefault(require("../compiler/registrar"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Allows you to define to a component in MSON, which isn't built until the component is
// instantiated
var MSONComponent = /*#__PURE__*/function (_WrappedComponent) {
  (0, _inherits2.default)(MSONComponent, _WrappedComponent);

  var _super = _createSuper(MSONComponent);

  function MSONComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MSONComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'MSONComponent');
    return _this;
  }

  (0, _createClass2.default)(MSONComponent, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(MSONComponent.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'definition',
            component: 'Field',
            required: true
          }]
        }
      }); // We want the class name to be that of the wrapped component

      this._preserveClassName = false; // For mocking

      this._registrar = _registrar.default;
    } // Set the compiler so that we can have separate compiler spaces per list of components

  }, {
    key: "_setCompiler",
    value: function _setCompiler(compiler) {
      this._compiler = compiler;
    }
  }, {
    key: "_getCompiler",
    value: function _getCompiler() {
      var compiler = this._compiler ? this._compiler : this._registrar.compiler;

      if (compiler) {
        return compiler;
      } else {
        throw new Error('compiler has not been registered with registrar');
      }
    }
  }, {
    key: "set",
    value: function set(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(MSONComponent.prototype), "set", this).call(this, props);

      if (props.definition !== undefined) {
        var compiler = this._getCompiler();

        var component = compiler.newComponent(props.definition);
        this.setComponentToWrap(component);
      }
    }
  }]);
  return MSONComponent;
}(_wrappedComponent.default);

exports.default = MSONComponent;